import React from "react";
import type { IOccurrencesAssociatedVehicle, ResponseProps } from "../interfaces";
import { createState, useState, type State } from "@hookstate/core";
import { getOccurrencesAssociatedVehicleByOccurrenceType, getOccurrencesAssossiatedVehicleByBrand, getOccurrencesAssossiatedVehicleByCircunstance, getOccurrencesAssossiatedVehicleByDestination, getOccurrencesAssossiatedVehicleByModel, getOccurrencesAssossiatedVehicleByState, getOccurrencesAssossiatedVehicleBytype } from "../components/QualifiersCharts/VehicleChart/services";

interface IOccurrencesAssociatedVehihcleProps {
  readonly occurrencesAssociatedVehicle: IOccurrencesAssociatedVehicle;
  readonly loadingCharts: boolean;
};

const occurrencesAssociatedVehicleProps: Readonly<ResponseProps> = {
  item: null,
  value: null,
  total: null
};

const occurrencesAssociatedPeopleDefault: Readonly<IOccurrencesAssociatedVehicle> = {
  occurrencesAssociatedAssossiatedVehicleBytype: occurrencesAssociatedVehicleProps,
  occurrencesAssociatedVehicleByBrand: occurrencesAssociatedVehicleProps,
  occurrencesAssociatedVehicleByCircunstance: occurrencesAssociatedVehicleProps,
  occurrencesAssociatedVehicleByDestination: occurrencesAssociatedVehicleProps,
  occurrencesAssociatedVehicleByModel: occurrencesAssociatedVehicleProps,
  occurrencesAssociatedVehicleByState: occurrencesAssociatedVehicleProps,
  occurrencesAssociatedVehicleByOccurrenceType: occurrencesAssociatedVehicleProps
};

const store = createState<Readonly<IOccurrencesAssociatedVehihcleProps>>({
  occurrencesAssociatedVehicle: occurrencesAssociatedPeopleDefault,
  loadingCharts: true,
});

interface getAllsAssociatedPeopleDataProps {
  readonly startDate: string | null;
  readonly finishDate: string | null;
  readonly involvementTypeId: number | null;
  readonly destinationId: number | null;
  readonly vehicleCircunstanceId: number | null;
}

export default function useManagementQualifiersVehicleState() {
  const occurrencesAssociatedVehicle: State<Readonly<IOccurrencesAssociatedVehicle>> = useState(store.occurrencesAssociatedVehicle);
  const loadingCharts = useState(store.loadingCharts)

  async function getAssociatedVehicleStats({startDate, finishDate, vehicleCircunstanceId, destinationId, involvementTypeId }: getAllsAssociatedPeopleDataProps) {
    const params = { startDate, finishDate, involvementTypeId, vehicleCircunstanceId, destinationId };
    
    const mapResponse = (response) =>
      response.map(({ item, value, total }) => ({ label: item, value, total }))
  
    loadingCharts.set(true)

    Promise.all([
      getOccurrencesAssossiatedVehicleBytype(params).then((response) => {
        occurrencesAssociatedVehicle.occurrencesAssociatedAssossiatedVehicleBytype.set(response)
      }),
      getOccurrencesAssossiatedVehicleByBrand(params).then((response) => {
        occurrencesAssociatedVehicle.occurrencesAssociatedVehicleByBrand.set(response)
      }),
      getOccurrencesAssossiatedVehicleByModel(params).then((response) => {
        occurrencesAssociatedVehicle.occurrencesAssociatedVehicleByModel.set(response)
      }),
      getOccurrencesAssossiatedVehicleByState(params).then((response) => {
        occurrencesAssociatedVehicle.occurrencesAssociatedVehicleByState.set(response)
      }),
      getOccurrencesAssossiatedVehicleByDestination(params).then((response) => {
        occurrencesAssociatedVehicle.occurrencesAssociatedVehicleByDestination.set(response)
      }),
      getOccurrencesAssossiatedVehicleByCircunstance(params).then((response) => {
        occurrencesAssociatedVehicle.occurrencesAssociatedVehicleByCircunstance.set(response)
      }),
      getOccurrencesAssociatedVehicleByOccurrenceType(params).then((response) => {
        occurrencesAssociatedVehicle.occurrencesAssociatedVehicleByOccurrenceType.set(response)
      }),
    ]).finally(() => {
      loadingCharts.set(false)
    })
  }


  return {
    occurrencesAssociatedVehicle: () => occurrencesAssociatedVehicle,
    fetchAllAssociatedVehicleData: async({
      destinationId,
      finishDate,
      involvementTypeId,
      vehicleCircunstanceId,
      startDate
    }) => getAssociatedVehicleStats({
      destinationId: destinationId,
      finishDate: finishDate,
      involvementTypeId: involvementTypeId,
      vehicleCircunstanceId: vehicleCircunstanceId,
      startDate: startDate
    }),
    loadingCharts: loadingCharts
  }
}